import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { Tooltip } from '@mui/material';
import Decimal from 'decimal.js';

import AcTooltip from 'components/AcTooltip/AcTooltip';
import { PricingMeta } from 'components/Pricing/Pricing.types';

import { ConvertedPriceParams } from '../common/contracts';

import { isPriceLocalized } from './isPriceLocalized';

export const getConvertedPrice = (
  params: ConvertedPriceParams | any,
  pricePoints: PricingMeta[]
) => {
  // Handle both old format (ConvertedPriceParams) and new format (direct offer object)
  const productsSequence =
    params.row?.productsSequence || params.productsSequence;

  if (!productsSequence || !Array.isArray(productsSequence)) {
    return <span>No price data</span>;
  }

  return (
    <>
      {productsSequence.map(
        ({ priceInUsdCents }: { priceInUsdCents: number }, index) => {
          if (priceInUsdCents === 0) {
            return <span key={index}>Free</span>;
          } else {
            const price = new Decimal(priceInUsdCents)
              .dividedBy(100)
              .toFixed(2);
            return (
              <div
                key={index}
                className="flex items-center"
                style={{ minWidth: '100%' }}
              >
                <span>{`$${price}`}</span>
                {isPriceLocalized(priceInUsdCents, pricePoints) ? (
                  ''
                ) : (
                  <Tooltip
                    arrow
                    style={{ marginLeft: '2px', height: '16px' }}
                    title={
                      <AcTooltip content={'Price point is not localized'} />
                    }
                  >
                    <ErrorOutlineOutlinedIcon sx={{ color: '#A8A9B2' }} />
                  </Tooltip>
                )}
              </div>
            );
          }
        }
      )}
    </>
  );
};
